import { Button } from "components/DesignSystem/Button/Button";
import { StepRow } from "pages/Books/BooksHome/GetStartedCard";
import { PHASE } from "../constants";
import { VerifyCardWrapper } from "./VerifyCardWrapper";
import { CalendlyModal } from "components/DesignSystem/CalendlyModal/CalendlyModal";
import { useModal } from "hooks/useModal";
import {
  BOOKKEEPING_CONSULTATION,
  SALES_DEMO,
} from "constants/meetingRequestUrls";

type Phase = typeof PHASE.SCREEN1 | typeof PHASE.SCREEN2;

const SUBTITLE: Record<Phase, string> = {
  [PHASE.SCREEN1]:
    "Please give us a moment to set up your workspace. This usually takes less than 2 minutes.",
  [PHASE.SCREEN2]:
    "Please give us a moment to set up your workspace and verify your entity details. This usually takes less than 2 minutes.",
};

export const VerifySetupSteps = ({ phase }: { phase: Phase }) => {
  const isScreen1 = phase === PHASE.SCREEN1;
  const showCalendly = useModal();

  return (
    <VerifyCardWrapper>
      <div className="t-space-y-2">
        <div className="t-text-subtitle-lg t-text-text-100">
          Setting up your account
        </div>
        <div className="t-text-body-sm t-text-text-30">{SUBTITLE[phase]}</div>
      </div>

      <div>
        <StepRow
          title="Creating your account"
          description=""
          isCompleted
          isLast={false}
        />
        <StepRow
          title="Setting up your workspace"
          description=""
          isCompleted={!isScreen1}
          isActive={isScreen1}
          showPulse={isScreen1}
          isLast={false}
        />
        <StepRow
          title="Verifying your entity details"
          description=""
          isActive={!isScreen1}
          showPulse={!isScreen1}
          isDisabled={isScreen1}
          isLast
        />
      </div>

      <div className="t-border-b-0 t-border-l-0 t-border-r-0 t-border-dashed t-border-t-[1px] t-border-neutral-10 t-pt-[18px] t-space-y-2">
        <div className="t-text-body-sm t-text-text-30">
          While we set up for you
        </div>
        <div>
          <Button customType="primary" size="small" onClick={showCalendly.open}>
            Meet our expert
          </Button>
        </div>
        {showCalendly.isOpen && (
          <CalendlyModal
            {...showCalendly}
            calendlyLink={SALES_DEMO}
            title="Meet Our Expert"
          />
        )}
      </div>
    </VerifyCardWrapper>
  );
};
